import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/priceinfo.css';
import styled, { cutDates, inputStyles, stockNumber } from '../../../Utils/inputChanges';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button, CircularProgress } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import ReactToPrint from 'react-to-print';
import { insertTransferManualStk } from '../../../Store/PHPSlice/Stock/StockApis';
import DropdownWithBtn from '../../FieldsComponents/DropdownWithBtn';
import { fetchLocationData } from '../../../Store/PHPSlice/Transport';
import { selectlocationdata } from '../../Selectors/Master/ItemSelectors';
import { StockMenu } from '../../TitleList';
import TitleBar from '../../TitleBar';
import axios from 'axios';
import DateInputComponent from '../../FieldsComponents/DateInputComponent';
import { getCurrentDate } from '../../../Utils/Dateutils';


const ManualStkTransfer = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        trmemo: '',
        new_locId: '',
        bailNo: '',
        locNm: '',
        userId: userdata?.ID,
        completeTr: 'yes'
    });

    const [stkdata, setStkdata] = useState([]);
    const [selectedStkData, setSelectedStkData] = useState([]);
    const [bailNoList, setBailNoList] = useState([]);

    const dispatch = useDispatch();

    const loclist = useSelector(selectlocationdata);

    const [openDropdowns, setOpenDropdowns] = useState({});

    const [loading, setLoading] = useState(false);

    const actionMap = {

    }
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef();

    useEffect(() => {

        dispatch(fetchLocationData());
        fetchBailNos();
    }, [dispatch]);

    const fetchBailNos = async (id) => {
        try {
            const endpoint = id ? `getGarmentStockBailNosForTransfer&locNm=${id}` : `getGarmentStockBailNosForTransfer`;
            const res = await axios.get(
                `${baseUrl}?apicall=${endpoint}`
            );
            // console.log(res.data);
            setBailNoList(res.data?.data);
            setFormData(prev => ({
                ...prev,
                trmemo: res?.data?.trmemo
            }))
        } catch (error) {
            console.error("Error fetching bail numbers:", error);
        }
    };


    const fetchManualStkItems = async (id) => {
        try {
            const res = await axios.get(`${baseUrl}?apicall=getManualStkBailNosItems&mstkId=${id}`);
            const item = res?.data?.data;
            const info = res?.data?.info;
            const total = info?.reduce((acc, sum) => acc + parseFloat(sum.qty), 0);
            setFormData(prev => ({
                ...prev,
                date: item.date,
                itemNm: item.itemNm,
                new_mcloth: item.mcloth,
                mclothNm: item.mclothNm,
                m1clothNm: item.m1clothNm,
                m2clothNm: item.m2clothNm,
                m3clothNm: item.m3clothNm,
                rack: item.rack,
                locNm: item.locNm,
                bailno: item.bailno,
                totqty: total
            }));

            setStkdata(info);
        } catch (error) {
            console.error(error);
        }
    }


    useEffect(() => {

        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [openDropdowns, dispatch]);

    // console.log(formData);
    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };

    const handleChange = (index, e) => {
        const { name, value } = e.target;

        // Allow only numbers
        if (!/^\d*$/.test(value)) return;

        const updated = [...stkdata];
        const row = updated[index];

        const balqty = Number(row.balqty) || 0;
        const trqty = value === "" ? 0 : Number(value);

        // ❌ Prevent entering more than balance qty
        if (trqty > balqty) return;

        updated[index] = {
            ...row,
            trqty: value === "" ? "" : trqty,
            bqty: balqty - trqty
        };

        if (updated[index].bqty > 0) {
            setFormData(prev => ({
                ...prev,
                completeTr: 'no'
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                completeTr: 'yes'
            }));
        }
        setStkdata(updated);
    };

    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });

    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });

        switch (dropdownType) {
            case 'bailNo':
                if (value) {
                    fetchManualStkItems(value);
                    setSelectedStkData([]);
                    setStkdata([]);
                } else {
                    setFormData(prev => ({
                        ...prev,
                        locNm: ""
                    }));
                    setSelectedStkData([]);
                    setStkdata([]);
                }
                break;
            case 'locNm':
                if (value) {
                    fetchBailNos(value);
                } else {
                    setBailNoList([]);
                }
                break;

            default:
                break;
        }
    };

    const handleCheckboxChange = (item, index) => {
        setSelectedStkData(prev => {
            const exists = prev.find(i => i.ID === item.ID);

            if (exists) {
                // ❌ Remove if unchecked
                return prev.filter(i => i.ID !== item.ID);
            } else {
                // ✅ Add if checked
                return [...prev, stkdata[index]];
            }
        });
    };



    const handleItemNew = () => {
        window.open(`/NewClothEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };



    const dropdownlistfirst = [
        {
            label: 'From Location',
            id: 'locNm',
            options: loclist?.data || [],
            value: formData.locNm,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'locNm', value: newValue ? newValue.locNm : '' } }, 'locNm'),
            getOptionLabel: (option) => option.locNm || '',
            isOptionEqualToValue: (option, value) => option.locNm === value.locNm,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.locNm === value) || null;
                }
                return null;
            },

        },
        {
            label: 'Bail No.',
            id: 'bailNo',
            options: bailNoList || [],
            value: formData.bailNo,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'bailNo', value: newValue ? newValue.ID : '' } }, 'bailNo'),
            getOptionLabel: (option) => option.bailno || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },

        },

    ];

    const fields = [
        { label: 'Date', name: 'dt', type: 'date' },
        { label: 'Memo', name: 'trmemo', type: 'readOnly' }
    ];

    const fields2 = [
        { label: 'Prvious Location', name: 'locNm', type: 'readOnly' }
    ];


    const transferDropdown = [

        {
            label: 'Transfer Location',
            id: 'new_locId',
            options: loclist?.data?.filter(item => item.locNm !== formData.locNm) || [],
            value: formData.new_locId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'new_locId', value: newValue ? newValue.locNm : '' } }, 'new_locId'),
            getOptionLabel: (option) => option.locNm || '',
            isOptionEqualToValue: (option, value) => option.locNm === value.locNm,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.locNm === value) || null;
                }
                return null;
            },

        },

    ];



    function postobj(formData, selectedStkData) {

        const data = {
            mstkId: formData.bailNo,
            dt: formData.dt,
            trmemo: formData.trmemo,
            locNm: formData.new_locId,
            completeTr: formData.completeTr,
            selectedStkData: selectedStkData || [],
            userId: formData.userId,
        };
        return data;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);
        try {
            const postData = postobj(formData, selectedStkData);
            // console.log(postData);

            const result = await dispatch(insertTransferManualStk(postData)).unwrap();
            console.log('POST request successful!', result);
            alert("Transfer Stock Added Successfully");
            window.location.reload();
        } catch (error) {
            console.error('Error while making POST request:', error);
        } finally {
            setLoading(false);
        }
    };

    // console.log(selectedStkData)
    return (
        <>
            <TitleBar data={StockMenu} />
            <Grid container>
                <h2 style={{ textAlign: 'center' }}>Manual Stock (Bail) Transfer</h2>
                <Grid item xs={12}>
                    <Paper style={{ padding: '3vh', margin: '0' }}>
                        <Grid container spacing={0.5}>

                            {fields?.map((field) => (
                                <DateInputComponent
                                    key={field.name}
                                    formData={formData}
                                    handleDateChange={handleDateChange}
                                    handleInputChange={handleInputChange}
                                    styled={styled}
                                    inputStyles={inputStyles}
                                    isDesktop={isDesktop}
                                    field={field}
                                />
                            ))}

                            {
                                dropdownlistfirst && dropdownlistfirst?.map((drop) => (
                                    <DropdownWithBtn
                                        key={drop.label}
                                        label={drop.label}
                                        id={drop.id}
                                        options={drop.options}
                                        value={drop.value}
                                        onChange={drop.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={drop.getOptionLabel}
                                        isOptionEqualToValue={drop.isOptionEqualToValue}
                                        valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        handleAddNew={drop.handleAddNew}
                                        btnlabel={drop.btnlabel}
                                        handleDropdownOpen={drop.handleDropdownOpen}
                                        handleDropdownClose={drop.handleDropdownClose}
                                    />
                                ))
                            }



                            {
                                transferDropdown && transferDropdown?.map((drop) => (
                                    <DropdownWithBtn
                                        key={drop.label}
                                        label={drop.label}
                                        id={drop.id}
                                        options={drop.options}
                                        value={drop.value}
                                        onChange={drop.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={drop.getOptionLabel}
                                        isOptionEqualToValue={drop.isOptionEqualToValue}
                                        valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        handleAddNew={drop.handleAddNew}
                                        btnlabel={drop.btnlabel}
                                        handleDropdownOpen={drop.handleDropdownOpen}
                                        handleDropdownClose={drop.handleDropdownClose}
                                    />
                                ))
                            }


                            <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                <Table>
                                    <TableHead>
                                        <TableRow className='tbl-row'>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Size</TableCell>
                                            {/* <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Color</TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Shade No.</TableCell> */}
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Rate</TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Stk Qty.</TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Transfer Qty.</TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Bal Qty.</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {Array.isArray(stkdata) && stkdata?.length > 0 ? (
                                            stkdata?.map((item, index) => (
                                                <TableRow key={index}>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedStkData.some(i => i.ID === item.ID)}
                                                            onChange={() => handleCheckboxChange(item, index)}
                                                        />{" "}
                                                        {index + 1}
                                                    </TableCell>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{item.size}</TableCell>
                                                    {/* <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                        {item.color || ""}
                                                    </TableCell>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                        {item.shadeNo || ""}
                                                    </TableCell> */}
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{item.rate}</TableCell>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{item.balqty}</TableCell>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                        <input
                                                            type="text"
                                                            name="trqty"
                                                            value={item.trqty}
                                                            style={{ width: '100px', padding: '2px', outline: 'none' }}
                                                            onChange={(e) => handleChange(index, e)}
                                                        />

                                                    </TableCell>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{item.bqty}</TableCell>
                                                </TableRow>
                                            ))

                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={8} align='center' sx={{ p: 0.4, border: '1px solid #000' }}>No data available</TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>


                            <Grid item xs={12} textAlign="center">
                                <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                    {
                                        loading === true ?
                                            <><CircularProgress size="20px" /> wait...</> :
                                            "Submit"
                                    }
                                </Button>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
        </>
    );
};

export default ManualStkTransfer;
